import { TOptions } from 'i18next';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';

export type ValidatorMessage = string | [string, TOptions];

export type Validator<T = any, VS = any> = (
  value: T | undefined,
  values: VS,
  length?: number
) => ValidatorMessage | void;

export function composeValidators<T>(
  ...validators: Validator<T>[]
): Validator<T> {
  return (...args) => {
    for (let validator of validators) {
      const error = validator(...args);

      if (error != null) return error;
    }
  };
}

export const requiredFactory: (msg: ValidatorMessage) => Validator<any> = (
  msg
) => (value) => (value == null ? msg : undefined);

export const required = requiredFactory('validation:required');

export function regex<T extends string>(
  re: RegExp,
  msg: ValidatorMessage
): Validator<T> {
  return (value) =>
    value == null ? undefined : re.test(value) ? undefined : msg;
}

// eslint-disable-next-line
export const dateRe = /^((0[1-9]|[12][0-9]|3[01])(\/)(0[13578]|1[02]))|((0[1-9]|[12][0-9])(\/)(02))|((0[1-9]|[12][0-9]|3[0])(\/)(0[469]|11))(\/)\d{4}$/;
export const dateRegexValidator = regex(dateRe, 'validation:invalid');

export const adultValidator: Validator<string> = (dob) => {
  if (dob == null) return undefined;

  const [day, month, year] = dob.split('/');

  const myDob = new Date(`${month}/${day}/${year}`);
  const today = new Date();
  const maxDob = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
  );

  return maxDob.getTime() > myDob.getTime() ? undefined : 'validation:age18';
};

export const numberPhoneValidator: Validator<string> = (
  value,
  country?: string
) => {
  return value != null &&
    value.length !== 0 &&
    (country == null
      ? isValidPhoneNumber(value.toString())
      : isValidPhoneNumber(value.toString(), country as CountryCode))
    ? undefined
    : 'validation:invalid';
};

export const validateDate = composeValidators(
  required,
  dateRegexValidator,
  adultValidator
);
